define("shared/utils/plan-rec-analytics/index", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.QUESTION_PROPERTY = _exports.PLAN_REC_EVENTS = void 0;
  _exports.answerProperties = answerProperties;
  _exports.buildRecommendationPayload = buildRecommendationPayload;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Amplitude event names, as product specified them (LS-9848). Product-facing: renaming one breaks
   * the analyst's charts, so change them only with a spec change.
   */
  const PLAN_REC_EVENTS = _exports.PLAN_REC_EVENTS = {
    answered: 'added_onboarding_info',
    skipped: 'skipped_onboarding_info',
    shown: 'personalized_plan_rec',
    clickedCta: 'clicked_personalized_plan_rec_cta',
    dismissed: 'dismissed_personalized_plan_rec',
    clickedSeeAllPlans: 'clicked_see_all_plans',
    converted: 'converted_personalized_plan_rec',
    abandoned: 'abandoned_personalized_plan_rec'
  };

  /** Each answer under its product-specified property. Values are the stored column strings, untranslated. */

  const QUESTION_PROPERTY = _exports.QUESTION_PROPERTY = {
    role: 'social-media-management',
    profiles: 'social-profile-management',
    goal: 'primary-user-goal'
  };

  /** The checkout's Back button reaches the plan picker, so what was bought need not be what was recommended. */

  /**
   * A skipped question is an absent key, never a sentinel: the server-side record of a skip is a
   * NULL column, and the two halves must reconcile by equality.
   */
  function answerProperties(answers) {
    const properties = {};
    if (answers.role) {
      properties['social-media-management'] = answers.role;
    }
    if (answers.profiles) {
      properties['social-profile-management'] = answers.profiles;
    }
    if (answers.goal) {
      properties['primary-user-goal'] = answers.goal;
    }
    return properties;
  }

  /** The payload every card and checkout event shares with the recommendation-shown event. */
  function buildRecommendationPayload(_ref, answers) {
    let {
      tier,
      winningTerm
    } = _ref;
    return {
      tier,
      'winning-term': winningTerm,
      ...answerProperties(answers)
    };
  }
});